export default "../css/c9a0d06db60f5cd270d4b669b1dd717f.ttf";